import React from 'react';

import Modal from 'components/Modal';
import ChangeUsernameForm from './ChangeUsernameForm';
import CompleteMessage from './CompleteMessage';

export default function ChangeUsernameModalComponent(props) {
  const {
    isComplete,
    isOpen,
    onRequestClose,
    onSubmit,
    successMessage,
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      {isComplete ? <CompleteMessage message={successMessage} /> : <ChangeUsernameForm onSubmit={onSubmit} />}
    </Modal>
  );
}